import { render } from "./DiscountPreview.vue?vue&type=template&id=c706e67c&scoped=true"
import script from "./DiscountPreview.vue?vue&type=script&lang=js"
export * from "./DiscountPreview.vue?vue&type=script&lang=js"

import "./DiscountPreview.vue?vue&type=style&index=0&id=c706e67c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c706e67c"]])

export default __exports__